
export default {
  props: {
    // v-model="curPage" 로부터 전달 받음
    value: {
      type: Number,
      default: null,
    },
    itemTotalCount: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 5,
    },
    blockSize: {
      type: Number,
      default: 5,
    },
  },

  data() {
    return {}
  },

  computed: {
    totalCount() {
      return isNaN(this.itemTotalCount) ? 0 : this.itemTotalCount
    },
    pages() {
      const pages = []

      // 현재 page 블럭, this.value 는 curPage 임, 1부터 시작
      const curBlock = Math.ceil(this.value / this.blockSize)

      // 마지막 페이지
      const lastPage = Math.ceil(this.totalCount / this.pageSize)
      // 마지막 페이지까지만 페이지 표시
      for (let index = 0; index < this.blockSize; index++) {
        const page = (curBlock - 1) * this.blockSize + index + 1
        if (page > lastPage) {
          break
        }
        pages.push(page)
      }
      return pages
    },
    lastBlock() {
      return Math.ceil(this.totalCount / this.pageSize / this.blockSize)
    },
    curBlock() {
      return Math.ceil(this.value / this.blockSize)
    },
  },

  methods: {
    onClickPrev() {
      // 현재 페이지 그룹 -1 * 페이지그룹 사이즈  ex) group:2 size:5 (2-1) * 5 = 5
      this.onClickPage((this.curBlock - 1) * this.blockSize)
    },
    onClickNext() {
      this.onClickPage(this.curBlock * this.blockSize + 1)
    },

    onClickPage(page) {
      this.$emit('clickPage', page)
    },
  },
}
